export const isStrictlyBetween = (value: number, min: number, max: number) => {
  return value > min && value < max;
};
